"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocalizedString = getLocalizedString;
exports.getDefaultString = getDefaultString;
exports.clearLocaleCache = clearLocaleCache;
const tslib_1 = require("tslib");
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const fs_extra_1 = tslib_1.__importDefault(require("fs-extra"));
const os_1 = tslib_1.__importDefault(require("os"));
const path = tslib_1.__importStar(require("path"));
const util = tslib_1.__importStar(require("util"));
const templateHelper_1 = require("../component/generator/templateHelper");
const folder_1 = require("../folder");
const globalVars_1 = require("./globalVars");
const LocaleStringMap = new Map();
function loadTranslationFile(translationFolder, locale) {
    const nlsFileName = locale ? `package.nls.${locale}.json` : "package.nls.json";
    let nlsFilePath = path.join(translationFolder, nlsFileName);
    if (!fs_extra_1.default.pathExistsSync(nlsFilePath)) {
        // if nls file does not exist, just read the default one
        nlsFilePath = path.join(translationFolder, "package.nls.json");
    }
    const json = fs_extra_1.default.readJSONSync(nlsFilePath);
    if (json) {
        const existing = LocaleStringMap.get(locale);
        if (existing) {
            LocaleStringMap.set(locale, { ...existing, ...json });
        }
        else {
            LocaleStringMap.set(locale, json);
        }
    }
}
function getLocaleJson(locale) {
    locale = locale || "";
    const jsonInMap = LocaleStringMap.get(locale);
    if (jsonInMap)
        return jsonInMap;
    // fx-core translation files
    loadTranslationFile((0, folder_1.getResourceFolder)(), locale);
    // template translation files
    const cachedResourcePath = path.join(os_1.default.homedir(), `.${String(teamsfx_api_1.ConfigFolderName)}`, "ui", "resource");
    // Check if cached resource folder exists, otherwise fallback to bundled templates resource folder
    if (!(0, templateHelper_1.useLocalTemplate)() &&
        cachedResourcePath &&
        fs_extra_1.default.pathExistsSync(path.join(cachedResourcePath, "package.nls.json"))) {
        loadTranslationFile(cachedResourcePath, locale);
    }
    else {
        loadTranslationFile(path.join((0, folder_1.getResourceFolder)(), "templates"), locale);
    }
    return LocaleStringMap.get(locale);
}
function getLocalizedString(key, ...params) {
    const json = getLocaleJson(globalVars_1.Locale);
    let value = json[key];
    if (value && params && params.length > 0) {
        value = util.format(value, ...params);
    }
    if (!value) {
        return getDefaultString(key, ...params);
    }
    return value || "";
}
function getDefaultString(key, ...params) {
    const json = getLocaleJson("");
    let value = json[key];
    if (value && params && params.length > 0) {
        value = util.format(value, ...params);
    }
    return value || "";
}
/**
 * Clear the locale string cache so that updated NLS files (e.g., from a freshly
 * downloaded metadata.zip) are picked up on next getLocalizedString() call.
 */
function clearLocaleCache() {
    LocaleStringMap.clear();
}
//# sourceMappingURL=localizeUtils.js.map